export default "__VITE_ASSET__DkitJW5g__"